'use client';

import { useEffect, useRef } from 'react';
import { trackAmplitudeEvent } from '@monoimin/analytics';

interface ReadMoreTrackingProps {
  title: string | undefined;
  articleSlugs: string[];
  locale: string;
}

export const ReadMoreTracking = ({
  title,
  articleSlugs,
  locale,
}: ReadMoreTrackingProps) => {
  const viewTracked = useRef<boolean>(false);
  const containerRef = useRef<HTMLDivElement>(null);

  // Track view event
  useEffect(() => {
    if (!containerRef.current || viewTracked.current) return;

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          trackAmplitudeEvent({
            deviceId: '',
            userId: null,
            name: 'Read More Block View',
            properties: {
              carousel_type: 'read_more',
              carousel_title: title || 'Read More',
              article_count: articleSlugs.length,
              language: locale,
            },
          });
          viewTracked.current = true;
          observer.disconnect();
        }
      },
      { threshold: 0.3 }
    );

    observer.observe(containerRef.current);
    return () => observer.disconnect();
  }, [title, articleSlugs, locale]);

  // Just render a reference div for view tracking
  return <div ref={containerRef} />;
};
